import { Image } from "@chakra-ui/react";
import React from "react";

const Certificate = () => {
  return (
    <div style={{ marginTop: "10%" }}>
      {/* import navbar here */}

      <Image
        width="100%"
        height="100%"
        src="https://d2407na1z3fc0t.cloudfront.net/Banner/certificate_new_2022.png"
      />

      {/* footer section */}
    </div>
  );
};

export default Certificate;
